module.exports = __webpack_public_path__ + "static/img/zhuangshi03.5fb5c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhuangshi03.png
// module id = g6By
// module chunks = 60